/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A published question as every reader sees it.
 * 
 * Deliberately carries no asker, team, organization, original text or answerer: nothing
 * here may identify who asked. `published_text` is null for an announcement.
 * @export
 * @interface EventQuestionPublicRead
 */
export interface EventQuestionPublicRead {
    /**
     * 
     * @type {string}
     * @memberof EventQuestionPublicRead
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof EventQuestionPublicRead
     */
    published_text?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EventQuestionPublicRead
     */
    answer_text: string;
    /**
     * 
     * @type {Date}
     * @memberof EventQuestionPublicRead
     */
    published_at: Date;
}

/**
 * Check if a given object implements the EventQuestionPublicRead interface.
 */
export function instanceOfEventQuestionPublicRead(value: object): value is EventQuestionPublicRead {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('answer_text' in value) || value['answer_text'] === undefined) return false;
    if (!('published_at' in value) || value['published_at'] === undefined) return false;
    return true;
}

export function EventQuestionPublicReadFromJSON(json: any): EventQuestionPublicRead {
    return EventQuestionPublicReadFromJSONTyped(json, false);
}

export function EventQuestionPublicReadFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventQuestionPublicRead {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'published_text': json['published_text'] == null ? undefined : json['published_text'],
        'answer_text': json['answer_text'],
        'published_at': (new Date(json['published_at'])),
    };
}

export function EventQuestionPublicReadToJSON(json: any): EventQuestionPublicRead {
    return EventQuestionPublicReadToJSONTyped(json, false);
}

export function EventQuestionPublicReadToJSONTyped(value?: EventQuestionPublicRead | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'published_text': value['published_text'],
        'answer_text': value['answer_text'],
        'published_at': ((value['published_at']).toISOString()),
    };
}

